import axios from "axios";
import sessionStorageService from "./sessionStorageService";
import { fetchDataV2 } from "./apiService";

const BASE_URL_API = process.env.REACT_APP_BASE_URL_API_CONFIG;


class JwtAuthService {
  loginWithToken = async () => {
    const data = await new Promise((resolve, reject) => {
      try {
        const userInfo = this.getUser();
        if (!userInfo) {
          // Se il token non è presente, lo consideriamo scaduto
          //reject("Il token è scaduto o non è valido.");
          // eseguo anche il logout 
          this.logout();
          reject();

        } else {
          const tokenParts = userInfo.accessToken.split('.');
          if (tokenParts.length === 3) {
            const payload = JSON.parse(atob(tokenParts[1]));
            const tokenExpirationDate = new Date(payload.exp * 1000);
            const currentDate = new Date();
            if (currentDate > tokenExpirationDate) {
              // Il token è scaduto
              this.logout();
              reject();
              //reject("Il token è scaduto.");
            } else {
              // Il token è valido
              _emitUserChange(this.getUser());
              resolve(this.getUser());
              //resolve("Il token è valido.");
            }
          } else {
            this.logout();
            reject();
            // Token malformato, consideriamo come scaduto
            //reject("Il token è scaduto o non è valido.");
          }
        }
      }
      catch (error) {
        console.log(error);
      }

    });
    // NON HO BEN CAPITO QUESTE ISTRUZIONI A COSA SERVONO
    //if (data) {
    //  this.setSession(data.token);
    //  this.setUser(data);
    //}
    return data;
  };

  loginWithEmailAndPassword = async (credential) => {
    const apiUrl = "Auth/Login";
    const payload = {
      email: credential.email,
      password: credential.password
    };
    try {
      const result = await fetchDataV2(apiUrl, payload, undefined, "POST");
      if (result) {
        this.setSession(result.token);
        this.setUser(result);
        _emitUserChange(result);
      }
      return result;
    } catch (error) {
      Promise.reject(error);
    }
  }

  /**
   * Registra il logout lato server (BlackBox GDPR).
   * Il token viene letto in modo sincrono PRIMA di qualsiasi await, quindi si può chiamare
   * senza await subito prima di logout(): non blocca mai il logout locale.
   */
  logoutServer = async () => {
    const userInfo = this.getUser();
    const token = this.getToken() || userInfo?.accessToken || userInfo?.token;
    if (!token) return;
    try {
      await axios.post("Auth/Logout", null, {
        baseURL: BASE_URL_API,
        headers: { Authorization: "Bearer " + token },
        timeout: 5000,
      });
    } catch (error) {
      console.log("Logout server", error);
    }
  };

  logout = () => {
    this.setSession(null);
    this.removeUser();
    this.removeToken();
    _emitUserChange(null);
  };

  setSession = (token) => {
    if (token) {
      sessionStorageService.setItem("jwt_token", token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
      sessionStorageService.removeItem("jwt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  setUser = (user) => {
    sessionStorageService.setItem("auth_user", user);
  };

  setAuthenticatedUser = (user) => {
    const session = { accessToken: user.token, user };
    this.setSession(user.token);
    this.setUser(session);
    _emitUserChange(user);
    return session;
  };

  getUser = () => {
    return sessionStorageService.getItem("auth_user");
  }

  removeUser = () => {
    sessionStorageService.removeItem("auth_user");
  };

  removeToken = () => {
    sessionStorageService.removeItem("jwt_token");
  };

  getToken = () => {
    return sessionStorageService.getItem("jwt_token");
  }

}
const _listeners = new Set();
function _emitUserChange(userObj) { for (const cb of _listeners) try { cb(userObj); } catch { } }
export function onAuthStateChanged(cb) { _listeners.add(cb); return () => _listeners.delete(cb); }

const instance = new JwtAuthService();
instance.onAuthStateChanged = onAuthStateChanged;
export default instance;
